import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/grab/posIntegration';
// 获取OAuth重定向URL
const getOAuthUrl = (systemSource, merchantId, branchId) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data`),
		{
			branchId,
		}
	);
};

// 获取门店绑定状态
const branchStatus = (
	systemSource,
	merchantId,
	branchId,
	companyCode = 'Grab'
) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-cooperation/${merchantId}/onlineCooperationCompanyRelations`
		),
		{ branchId, companyCode }
	);
};

// 解绑门店 (旧版本)
const unbind = (systemSource, merchantId, branchId, operateBy) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/unbind`),
		{
			branchId,
			operateBy,
		}
	);
};

// 解绑门店 (新版本)
const removePosData = (systemSource, merchantId, branchId) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data/remove`),
		{
			branchId,
		}
	);
};

export default {
	getOAuthUrl,
	branchStatus,
	unbind,
	removePosData,
};
